module.exports = __webpack_public_path__ + "assets/pdf/SuyashFowdar.60579a39.pdf";